import React, { useState } from 'react';
import { connect } from 'react-redux';
import Snackbar from 'material-ui/Snackbar';
import { IconButton } from 'material-ui';
import { Clear } from '@material-ui/icons';
import Slide from 'material-ui/transitions/Slide';
import { closeMessage } from '../../state/common/messages/messagesReducer';
import { SnackbarContent } from "material-ui";


const Transition = props => <Slide direction="up" {...props} />;

//TODO: CSS
let CloseSnackbar = ({ close }) => (
    <IconButton onClick={close} color="primary">
        <Clear />
    </IconButton>
);

CloseSnackbar = connect(null, { close: closeMessage })(CloseSnackbar);

//Need to use React state here to store the message so that it doesn't disappear
//once the notification has been closed, since that makes the transition janky.
const AlertMessage = ({ open, onClose, messageValue, message }) => {
    const [messageToShow, setMessageToShow] = useState('');
    const [prevMessage, setPrevMessage] = useState('');

    // Derive state during render (replaces getDerivedStateFromProps)
    if (message && message !== prevMessage) {
        setPrevMessage(message);
        setMessageToShow(message);
    }

    return (
        <div>
        {messageValue === 'Recipient' &&
        <Snackbar
            open={open}
            onClose={onClose}
            transition={Transition}
            autoHideDuration={7000}
            action={<CloseSnackbar />}
        > 
        <SnackbarContent
                style={{backgroundColor:'#B22222'}}
                message={messageToShow}
            />
        </Snackbar>
        } 
         {messageValue !== 'Recipient' && 
         <Snackbar
            open={open}
            onClose={onClose}
            transition={Transition}
            message={messageToShow}
            action={<CloseSnackbar />}
        />
    }
    </div>
    )
};

export default AlertMessage;
